import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { ethers } from 'ethers';
import Bronze from '../../assets/icons/bronze.svg';
import Silver from '../../assets/icons/silver.svg';
import modalOpen from '../../assets/mypage_modal.png';
import Gold from '../../assets/icons/gold.svg';
import Black from '../../assets/icons/black.svg';
import Platinum from '../../assets/icons/platinum.svg';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import './MypageSwap.css';
import { bignumber, multiply } from 'mathjs';
import TermsOfServiceModal from '../../component/TermsOfServiceModal';
import '../../css/Mypage.css';
import Header from '../../component/header';
import Footer from '../../component/Footer';
import stakeLogo from '../../assets/stakelogo.svg';
import axios from 'axios';
import { _postStakingInfo, _stakingInfo } from '../../recoil-states/staking';
import { huobi_closing_price } from '../../recoil-states/huobi-api';
import { useRecoilState, useRecoilValue } from 'recoil';
import moment from 'moment';
import Loading from '../../component/Loading';
import {
	_getAllCollectionCategoryList,
	_getOnChainCollectionItems,
	_getOffChainCollectionProducts,
	_numbering,
	_exportTokenToLazyMint,
	_getOffChainCollectionBoxes,
	_unbox,
	_fixedPrice,
	_formatPrice,
	_categorizeAtKonnectWallet,
	_reportCompleteExportTokenToLazyMint,
	_inputActionLog,
	_getOffChainCollectionProductsAsEmail,
	_getOffChainCollectionBoxesAsEmail,
	moralis_db_update_rollback,
} from '../../function/functions';
import {
	languageSetting,
	translatedText,
} from '../../recoil-states/language-state';
import {
	CONTRACT_INFO,
	PFP_CONTRACT,
	SHILLA_CONTRACT,
	TOKEN_INFO,
} from '../../contract';
import KonnectWallet from './KonnectWallet';
import {
	BoxDetailModalOpen,
	membership_rank,
	WalletConnectModalOpen,
} from '../../recoil-states/user-state/user-state';
import { MembershipModal } from '../../component/MembershipModal';
import { OpenAnimationModal } from '../../component/OpenAnimationModal';
import ShillaOpenModal from '../../component/ShillaOpenModal';
import {
	OAuthData,
	OAuthDataState,
} from '../../recoil-states/user-state/user-OAuth';
import EditModal from '../../component/EditModal';
import BoxDetailModal from '../../component/detailModal/BoxDetailModal';
import {
	useAccount,
	useContractRead,
	useContractWrite,
	useNetwork,
	usePrepareContractWrite,
	useSigner,
	useWaitForTransaction,
	useBalance,
	useFeeData,
} from 'wagmi';
import { SwapWidget } from '@uniswap/widgets';
import '@uniswap/widgets/fonts.css';
import MyPageHeader from '../../component/Mypage/myPageHeader';
import M_Staking from '../../component/M_Staking';

const Mypage = ({ handleAuth }) => {
	const openBoxObj = {
		isOpen: false,
		imgUrl: null,
	};

	const membershipStandard_init = [
		{
			grade: 5,
			level: 'bronze',
			kct: 500,
			usdt: 100,
			img: Bronze,
		},
		{
			grade: 4,
			level: 'silver',
			kct: 5000,
			usdt: 50000,
			img: Silver,
		},
		{
			grade: 3,
			level: 'gold',
			kct: 30000,
			usdt: 300000,
			img: Gold,
		},
		{
			grade: 2,
			level: 'black',
			kct: 80000,
			usdt: 800000,
			img: Black,
		},
		{
			grade: 1,
			level: 'platinum',
			kct: 400000,
			usdt: 4000000,
			img: Platinum,
		},
	];
	const [language] = useRecoilState(languageSetting);
	const textData = useRecoilValue(translatedText);
	const [userMembership, setUserMemberShip] = useRecoilState(membership_rank);
	const [membership, setMembership] = useState('');
	const [userData, setUserData] = useRecoilState(OAuthData);
	const [walletConnectmodal, setWalletConnectModal] = useRecoilState(
		WalletConnectModalOpen
	);
	const [boxDetailModal, setBoxDetailModal] =
		useRecoilState(BoxDetailModalOpen);
	const [Category, setCategory] = useState('allCollection');
	const [termsModal, setTermsModal] = useState(false);
	const [stakeModal, setStakeModal] = useState(false);
	const [shillaModal, setShillaModal] = useState({
		isOpen: false,
		unbox: false,
		imgUrl: null,
	});
	const [shillaImg, setShillaImg] = useState('');
	const [myAddress, setMyAddress] = useState('');
	const [myBalance, setMyBalance] = useState('');
	const [userEth, setUserEth] = useState(0); // 유저의 이더
	const [inputAmountValue, setInputAmountValue] = useState(0);
	const [divideAmount, setDivideAmount] = useState('');
	const [durationApr, setDurationApr] = useState('180D');
	const [levelApr, setLevelApr] = useState(0);
	const [networkChain, setNetworkChain] = useState(''); // 현재 연결 된 네트워크체인
	const [levelAprPercent, setLevelAprPercent] = useState(1);
	const oauthState = useRecoilValue(OAuthDataState);
	const [nickName, setNickName] = useState(userData?.profile_nick_name);
	const [diffDay, setDiffDay] = useState(0);
	const [openBox, setOpenBox] = useState(openBoxObj);
	const [membershipStandard, setMembershipStandard] = useState(
		membershipStandard_init
	);
	const [loading, setLoading] = useState(false);
	const [onChainCollectionData, setOnChainCollectionData] = useState([]);
	const [offChainCollectionData, setOffChainCollectionData] = useState({});
	const [allCollectionData, setAllCollectionData] = useState([]);
	const [filteredAllCollectionData, setFilteredAllCollectionData] = useState(
		{}
	);
	const [categoryList_kw, setCategoryList_kw] = useState([]);
	const [selectedCategoryMain_kw, setSelectedCategoryMain_kw] = useState(0);
	const [selectedCategorySub_kw, setSelectedCategorySub_kw] = useState(0);
	const history = useHistory();
	const inputamount = useRef();
	const [Reward, setReward] = useState(0);
	const [nextMembershipPrice, setNextMembershipPrice] = useState(0);
	const [stakeBtnChecked, setStakeBtnChecked] = useState(false);
	const [sendingCheck, setSendingCheck] = useState(false);
	const [huobiPrice, setHuobiPrice] = useState(1);
	const [userStakingInfo, setUserStakingInfo] = useState([]);
	const [allUserAmount, setAllUserAmount] = useState(0);
	const [checkUserState, setCheckUserState] = useState('');
	const [myStakingMount, setMyStakingMount] = useState([]);
	const [checkUserStaking, setCheckUserStaking] = useState({});
	const [isStakeButtonActive, setIsStakeButtonActive] = useState(false);
	const [periodIndex, setPeriodIndex] = useState(0);
	const [shillaData, setShillaData] = useState({});
	const [prevUserAmount, setPrevUserAmount] = useState([]);
	const [newUserAmount, setNewUserAmount] = useState(0);
	const [bronzeAmountMin, setBronzeAmountMin] = useState(
		membershipStandard_init[0].usdt
	);
	const [silverAmountMin, setSilverAmountMin] = useState(
		membershipStandard_init[1].usdt
	);
	const [goldAmountMin, setGoldAmountMin] = useState(
		membershipStandard_init[2].usdt
	);
	const [blackAmountMin, setBlackAmountMin] = useState(
		membershipStandard_init[3].usdt
	);
	const [platinumAmountMin, setPlatinumAmountMin] = useState(
		membershipStandard_init[4].usdt
	);
	const [membershipModal, setMembershipModal] = useState(false);
	const [openEditModal, setOpenEditModal] = useState(false);
	const inputData =
		inputAmountValue &&
		levelAprPercent &&
		multiply(bignumber(inputAmountValue), bignumber(levelAprPercent));
	const loacalelang = localStorage.getItem('locale');
	const stakeInputBtn = useRef();
	const stakingAmountValue =
		inputAmountValue > 0
			? ethers.utils.parseEther(`${inputAmountValue}`)
			: 0;
	const { isConnected, isDisconnected, address } = useAccount();
	const { data: signer } = useSigner();
	const { chain, chains } = useNetwork();
	const chainId = chain ? chain?.id : chains[0]?.id;
	const chainNetWork = chain ? chain.network : '';
	const [_alluserAmount, _setAllUserAmount] = useState(0);
	const [userCandoStaking, setUserCandoStaking] = useState(false);
	const { data: gasData } = useFeeData();
	const inputRef = useRef();
	const NewUserAmount =
		userMembership !== 'N/A'
			? 1
			: userStakingInfo[0]?.claim_calculate_index[0].amount_min /
			  huobiPrice;
	const tierAmountMin = [
		bronzeAmountMin,
		silverAmountMin,
		goldAmountMin,
		blackAmountMin,
		platinumAmountMin,
	];
	/**
	 * wagmi hook KCT 잔액 조회 abi Read
	 * @function useContractRead
	 */
	const { data: balance_kct } = useContractRead({
		chainId,
		address: TOKEN_INFO.address,
		abi: TOKEN_INFO.abi,
		functionName: 'balanceOf',
		args: [`${address}`],
		watch: true,
		onError(error) {
			if (
				error.reason ===
				'resolver or addr is not configured for ENS name'
			) {
				console.warn = console.error = () => {};
			} else {
			}
		},
	});

	/**
	 * wagmi hook ETH Balance 호출
	 * @function useBalance
	 */
	const {
		data: balance_eth,
		isError,
		isLoading,
	} = useBalance({
		watch: true,
		chainId,
		addressOrName: address,
		onError(error) {
			if (
				error.reason ===
				'resolver or addr is not configured for ENS name'
			) {
				console.warn = console.error = () => {};
			} else {
			}
		},
	});

	/**
	 * wagmi hook Staking approve abi 사용 준비
	 * @function usePrepareContractWrite
	 */
	const { config: config_approve } = usePrepareContractWrite({
		chainId,
		address: TOKEN_INFO.address,
		abi: TOKEN_INFO.abi,
		functionName: 'approve',
		args: [CONTRACT_INFO.address, stakingAmountValue],
		onSuccess(data) {},
		onError(error) {
			if (
				error.reason ===
				'resolver or addr is not configured for ENS name'
			) {
				console.warn = console.error = () => {};
			} else {
			}
		},
	});
	/**
	 * wagmi hook Staking approve abi 사용
	 * @function useContractWrite
	 * @returns {function} execute_approve - staking approve 실행
	 */
	const { data: data_approve, write: execute_approve } = useContractWrite({
		...config_approve,
		onSuccess(data) {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'스테이킹 금액 전송 허용 트랜잭션 전송 성공',
				JSON.stringify(data)
			);
		},
		onError(error) {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'스테이킹 금액 전송 허용 트랜잭션 전송 실패',
				JSON.stringify(error)
			);
			let errorMessage =
				error.data.code === -32000
					? `${textData.mypage2.StakingError16}`
					: `${textData.mypage2.StakingError4}  ${
							textData && textData.mypage2.StakingError
					  }`;
			alert(errorMessage);
			setLoading(false);
		},
	});

	/**
	 * wagmi hook Staking 금액 전송 허용 요청
	 * @function useWaitForTransaction
	 */
	const {
		data: transactionReceipt_approve,
		isSuccess: waitIsSuccess_approve,
	} = useWaitForTransaction({
		chainId,
		hash: data_approve?.hash,
		onSettled(data, error) {
			if (data?.transactionHash.length > 1) {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'스테이킹 금액 전송 허용 성공',
					JSON.stringify(data)
				);
				_afterCheck_userIsStaking(data.transactionHash);
			} else {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'스테이킹 금액 전송 허용 실패',
					JSON.stringify(data)
				);
				alert(
					`${textData && textData.mypage2.StakingError4}  ${
						textData && textData.mypage2.StakingError
					}`
				);
				setLoading(false);
			}
		},
	});

	/**
	 * wagmi hook Staking 이자 계산 Conract abi 읽어옴
	 * @function useContractRead
	 */
	const { data: calculatedYield } = useContractRead({
		chainId,
		address: CONTRACT_INFO.address,
		abi: CONTRACT_INFO.abi,
		functionName: 'calculateYield',
		args: [`${address}`],
		onSuccess(data) {
			// _inputActionLog(
			// 	JSON.stringify(_inputLogAccount),
			// 	'스테이킹 이자 계산 성공',
			// 	JSON.stringify(data)
			// );
		},
		onError(error) {
			if (isConnected) {
				alert(`${textData && textData.mypage2.StakingError14}`);
			}
			if (
				error.reason !==
				'resolver or addr is not configured for ENS name'
			) {
				// _inputActionLog(
				// 	JSON.stringify(_inputLogAccount),
				// 	'스테이킹 이자 계산 실패',
				// 	JSON.stringify(error)
				// );
			} else {
				console.warn = console.error = () => {};
			}
		},
	});

	/**
	 * wagmi hook Staking 이자 계산 Conract abi 사용 준비
	 * @function usePrepareContractWrite
	 */
	const { config: config_claimYield } = usePrepareContractWrite({
		chainId,
		address: CONTRACT_INFO.address,
		abi: CONTRACT_INFO.abi,
		functionName: 'claimYield',
		onSuccess(data) {},
		onError(error) {},
	});
	/**
	 * wagmi hook Staking 이자 계산 Conract abi 사용
	 * @function useContractWrite
	 * @return {function} execute_claimYield
	 */
	const { data: data_claimYield, write: execute_claimYield } =
		useContractWrite({
			...config_claimYield,
			onSuccess(data) {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'스테이킹 이자 정산 트랜잭션 전송 성공',
					JSON.stringify(data)
				);
			},
			onError(error) {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'스테이킹 이자 정산 트랜잭션 전송 실패',
					JSON.stringify(error)
				);
			},
		});
	/**
	 * wagmi hook Staking 이자 계산 Conract abi 사용 응답
	 * @function useWaitForTransaction
	 */
	const {
		data: transactionReceipt_claimYield,
		isSuccess: waitIsSuccess_claimYield,
	} = useWaitForTransaction({
		chainId,
		hash: data_claimYield?.hash,
		onSuccess(data) {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'스테이킹 이자 정산 성공',
				JSON.stringify(data)
			);
			_request_userStaking_interest(data.transactionHash);
		},
		onError(error) {
			// _inputActionLog(
			// 	JSON.stringify(_inputLogAccount),
			// 	'스테이킹 이자 정산 실패',
			// 	JSON.stringify(error)
			// );
			alert(`${textData && textData.mypage2.StakingError11}`);
			setLoading(false);
		},
	});

	/**
	 * wagmi hook Staking 이자+원금 회수 Conract abi 사용 대기
	 * @function usePrepareContractWrite
	 */
	const { config: config_withdrawStake } = usePrepareContractWrite({
		chainId,
		address: CONTRACT_INFO.address,
		abi: CONTRACT_INFO.abi,
		functionName: 'WithdrawStake',
		onSuccess(data) {},
		onError(error) {
			if (
				process.env.REACT_APP_ENV === 'local' ||
				process.env.REACT_APP_ENV === 'testdev'
			) {
			}
		},
	});
	/**
	 * wagmi hook Staking 이자+원금 회수 Conract abi 사용
	 * @function useContractWrite
	 * @return {function} execute_withdrawStake
	 */
	const { data: data_withdrawStake, write: execute_withdrawStake } =
		useContractWrite({
			...config_withdrawStake,
			onSuccess(data) {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'스테이킹 원금 및 이자 정산 트랜잭션 전송 성공',
					JSON.stringify(data)
				);
			},
			onError(error) {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'스테이킹 원금 및 이자 정산 트랜잭션 전송 실패',
					JSON.stringify(error)
				);
			},
		});
	/**
	 * wagmi hook Staking 이자+원금 회수 Conract abi 응답 대기
	 * @function useWaitForTransaction
	 */
	const {
		data: transactionReceipt_withdrawStake,
		isSuccess: waitIsSuccess_withdrawStake,
	} = useWaitForTransaction({
		chainId,
		hash: data_withdrawStake?.hash,
		onSuccess(data) {
			// _inputActionLog(
			// 	JSON.stringify(_inputLogAccount),
			// 	'스테이킹 원금 및 이자 정산 성공',
			// 	JSON.stringify(data)
			// );
			request_userunstaking();
		},
		onError(error) {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'스테이킹 원금 및 이자 정산 실패',
				JSON.stringify(error)
			);
			alert(`${textData && textData.mypage2.StakingError13}`);
			setLoading(false);
		},
	});

	const _inputLogAccount = {
		address: address,
		subAddress: userData?.sub_wallet_address,
	};

	const swapTokenList = [
		{
			chainId,
			address: TOKEN_INFO.address,
			decimals: 18,
			name: 'Konnect',
			symbol: 'KCT',
			logoURI:
				'https://s2.coinmarketcap.com/static/img/coins/64x64/20305.png',
			// 'https://s2.coinmarketcap.com/static/img/coins/64x64/20729.png',
			// Bronze,
		},
	];

	const swapWidgetDesign = {
		container: '#FFFFFF',
		module: '#F8F8F8',
		interactive: '#87d4cb',
		accent: '#334B8C',
		secondary: '#505050',
	};

	/**
	 * staking 정보 호출 함수 묶음
	 * @async
	 * @function _checkUserData
	 */
	async function _checkUserData() {
		let funcArr = [_totalBalance(), _getstakingInfo(), postStakingInfo()];

		try {
			await Promise.allSettled(funcArr);
		} catch (error) {
			alert(textData.mypage2.StakingError15); // TODO : message input
		}
	}

	useEffect(() => {
		setNetworkChain(chain?.name);
		console.log(chain);
	}, [chain]);

	useEffect(() => {
		_houbiApiTime();
		if (balance_kct) {
			const realBalance = ethers.utils.formatUnits(balance_kct);
			setMyBalance(realBalance);
		}

		if (balance_eth) {
			setUserEth(balance_eth.formatted);
		}

		if (address) {
			_check_userIsStaking(address, userData?.sub_wallet_address);
			setMyAddress(address);
		}

		if (isConnected && address) {
			_checkUserData();
		}
	}, [isConnected, address, balance_kct, balance_eth, stakeBtnChecked]);

	useLayoutEffect(() => {
		_houbiApiTime();
		if (boxDetailModal) {
			setBoxDetailModal(false);
		}

		if (isConnected) {
			_checkUserData();
		}
	}, []);

	useEffect(() => {
		// 연결된 네트워크가 다른 네트워크인지 확인
		chainCheck();
	}, [isConnected, address, isConnected]);

	useLayoutEffect(() => {
		_getAmountMin();
	}, [userStakingInfo]);

	/**
	 * Staking 등급 도달에 필요한 최소값 계산
	 * @function _getAmountMin
	 * @returns {state} set(등급)AmountMin - 등급 도달에 필요한 최소값
	 */
	function _getAmountMin() {
		if (!userStakingInfo && !userStakingInfo[0]) return 0;
		setBronzeAmountMin(
			userStakingInfo[0]?.claim_calculate_index[0].amount_min
		);
		setSilverAmountMin(
			userStakingInfo[0]?.claim_calculate_index[2].amount_min
		);
		setGoldAmountMin(
			userStakingInfo[0]?.claim_calculate_index[4].amount_min
		);
		setBlackAmountMin(
			userStakingInfo[0]?.claim_calculate_index[1].amount_min
		);
		setPlatinumAmountMin(
			userStakingInfo[0]?.claim_calculate_index[3].amount_min
		);
	}

	useEffect(() => {
		const amount = (+inputAmountValue + myStakingMount) * huobiPrice;
		// const amount = (+inputAmountValue) * huobiPrice;
		const currentMembershipIndex = membershipStandard.findIndex(
			x => x.level === userMembership
		);
		if (
			bronzeAmountMin <= amount &&
			amount < silverAmountMin &&
			currentMembershipIndex <= 0
		) {
			setMembership('bronze');
		} else if (
			silverAmountMin <= amount &&
			amount < goldAmountMin &&
			currentMembershipIndex <= 1
		) {
			setMembership('silver');
		} else if (
			goldAmountMin <= amount &&
			amount < blackAmountMin &&
			currentMembershipIndex <= 2
		) {
			setMembership('gold');
		} else if (
			blackAmountMin <= amount &&
			amount < platinumAmountMin &&
			currentMembershipIndex <= 3
		) {
			setMembership('black');
		} else if (platinumAmountMin <= amount && currentMembershipIndex <= 4) {
			setMembership('platinum');
		} else {
			setMembership(userMembership);
		}

		setInputAmountValue(inputAmountValue >= 0 ? inputAmountValue : 0);

		if (
			userStakingInfo.length > 0 &&
			+inputAmountValue > 0 &&
			+inputAmountValue + newUserAmount >= NewUserAmount &&
			durationApr !== '' &&
			stakeBtnChecked
		) {
			setIsStakeButtonActive(true);
		} else {
			setIsStakeButtonActive(false);
		}
	}, [
		userStakingInfo,
		myStakingMount,
		inputAmountValue,
		bronzeAmountMin,
		silverAmountMin,
		goldAmountMin,
		blackAmountMin,
		platinumAmountMin,
		huobiPrice,
		membership,
		membershipStandard,
		userMembership,
		durationApr,
		stakeBtnChecked,
	]);

	/**
	 * staking 기간,이자율,등급을 설정하는 함수입니다
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _setMembership
	 */
	function _setMembership() {
		if (durationApr == '180D' && membership == 'bronze') {
			setLevelApr('bronze180D');
			setLevelAprPercent(0.01);
			setPeriodIndex(7);
		} else if (durationApr == '365D' && membership == 'bronze') {
			setLevelApr('bronze365D');
			setLevelAprPercent(0.012);
			setPeriodIndex(3);
		} else if (durationApr == '180D' && membership == 'silver') {
			setLevelApr('silver180D');
			setLevelAprPercent(0.02);
			setPeriodIndex(5);
		} else if (durationApr == '365D' && membership == 'silver') {
			setLevelApr('silver365D');
			setLevelAprPercent(0.025);
			setPeriodIndex(9);
		} else if (durationApr == '180D' && membership == 'gold') {
			setLevelApr('gold180D');
			setLevelAprPercent(0.03);
			setPeriodIndex(0);
		} else if (durationApr == '365D' && membership == 'gold') {
			setLevelApr('gold365D');
			setLevelAprPercent(0.04);
			setPeriodIndex(8);
		} else if (durationApr == '180D' && membership == 'black') {
			setLevelApr('black180D');
			setLevelAprPercent(0.05);
			setPeriodIndex(4);
		} else if (durationApr == '365D' && membership == 'black') {
			setLevelApr('black365D');
			setLevelAprPercent(0.08);
			setPeriodIndex(2);
		} else if (durationApr == '180D' && membership == 'platinum') {
			setLevelApr('platinum180D');
			setLevelAprPercent(0.07);
			setPeriodIndex(6);
		} else if (durationApr == '365D' && membership == 'platinum') {
			setLevelApr('platinum365D');
			setLevelAprPercent(0.1);
			setPeriodIndex(1);
		} else {
			setLevelApr('');
			setLevelAprPercent(0);
			setPeriodIndex(-1);
		}
	}

	useEffect(() => {
		const newMembershipStandard = membershipStandard_init.map(data => {
			let newUsdt;
			let newKct;
			switch (data.level) {
				case 'bronze':
					newUsdt = bronzeAmountMin;
					newKct = bronzeAmountMin / huobiPrice;
					break;
				case 'silver':
					newUsdt = silverAmountMin;
					newKct = silverAmountMin / huobiPrice;
					break;
				case 'gold':
					newUsdt = goldAmountMin;
					newKct = goldAmountMin / huobiPrice;
					break;
				case 'black':
					newUsdt = blackAmountMin;
					newKct = blackAmountMin / huobiPrice;
					break;
				case 'platinum':
					newUsdt = platinumAmountMin;
					newKct = platinumAmountMin / huobiPrice;
					break;
				default:
					newKct = 0;
					break;
			}
			const newObj = {
				...data,
				usdt: newUsdt,
				kct: newKct,
			};
			return newObj;
		});
		setMembershipStandard(newMembershipStandard);
	}, [
		userStakingInfo,
		myStakingMount,
		inputAmountValue,
		bronzeAmountMin,
		silverAmountMin,
		goldAmountMin,
		blackAmountMin,
		platinumAmountMin,
		huobiPrice,
	]);

	/**
	 * staking 유저 등급, 스테이킹 기간에 따른 이자율을 return 하는 함수입니다.
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _checkapr
	 * @returns {number} number - 이자율
	 */
	function _checkapr() {
		if (
			checkUserStaking.processing &&
			checkUserStaking.processing.length > 0 &&
			Object.keys(checkUserStaking.processing[0]).length > 0
		) {
			const stakingMount =
				checkUserStaking.processing[0].staking_mount * huobiPrice;
			if (
				stakingMount > bronzeAmountMin &&
				stakingMount < silverAmountMin &&
				checkUserStaking.processing[0].staking_period == 180
			) {
				return 1;
			} else if (
				stakingMount > bronzeAmountMin &&
				stakingMount < silverAmountMin &&
				checkUserStaking.processing[0].staking_period == 365
			) {
				return 1.2;
			} else if (
				stakingMount > silverAmountMin &&
				stakingMount < goldAmountMin &&
				checkUserStaking.processing[0].staking_period == 180
			) {
				return 2;
			} else if (
				stakingMount > silverAmountMin &&
				stakingMount < goldAmountMin &&
				checkUserStaking.processing[0].staking_period == 365
			) {
				return 2.5;
			} else if (
				stakingMount > goldAmountMin &&
				stakingMount < blackAmountMin &&
				checkUserStaking.processing[0].staking_period == 180
			) {
				return 3;
			} else if (
				stakingMount > goldAmountMin &&
				stakingMount < blackAmountMin &&
				checkUserStaking.processing[0].staking_period == 365
			) {
				return 4;
			} else if (
				stakingMount > blackAmountMin &&
				stakingMount < platinumAmountMin &&
				checkUserStaking.processing[0].staking_period == 180
			) {
				return 5;
			} else if (
				stakingMount > blackAmountMin &&
				stakingMount < platinumAmountMin &&
				checkUserStaking.processing[0].staking_period == 365
			) {
				return 8;
			} else if (
				stakingMount > platinumAmountMin &&
				checkUserStaking.processing[0].staking_period == 180
			) {
				return 7;
			} else if (
				stakingMount > platinumAmountMin &&
				checkUserStaking.processing[0].staking_period == 365
			) {
				return 10;
			} else {
				return 0;
			}
		} else {
			return 0;
		}
	}
	useEffect(() => {
		_setMembership();
	}, [inputAmountValue, durationApr, membership]);

	useEffect(() => {
		nextMembership();
	}, [myStakingMount, membershipStandard]);

	useEffect(() => {
		_calculReward();
	}, [inputAmountValue, durationApr, levelApr, divideAmount]);

	useEffect(() => {
		if (
			Object.keys(checkUserStaking).length > 0 &&
			checkUserStaking.processing.length > 0
		) {
			setDurationApr(`${checkUserStaking.processing[0].staking_period}D`);
		}
	}, [checkUserStaking]);

	useEffect(() => {
		// staking Period 날짜 차이 계산을 위한 변수입니다.
		const stakingStartDay =
			// Object.keys(checkUserStaking).length > 0 &&
			// checkUserStaking.processing.length > 0 &&
			// moment(checkUserStaking.processing[0].staking_start_date).format(
			// 	'YYYY/MM/DD'
			// );
			moment().format('YYYY/MM/DD');
		const stakingEndDay =
			Object.keys(checkUserStaking).length > 0 &&
			checkUserStaking.processing.length > 0 &&
			moment(checkUserStaking.processing[0].staking_end_date).format(
				'YYYY/MM/DD'
			);
		const DiffStakingDay = moment(stakingEndDay).diff(
			stakingStartDay,
			'days'
		);
		setDiffDay(DiffStakingDay);
	}, [checkUserStaking]);

	/**
	 * 체크박스 핸들링 함수입니다.
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _checkHandler
	 */
	const _checkHandler = () => {
		setStakeBtnChecked(!stakeBtnChecked);
	};

	/**
	 * 유저가 입력한 staking 값을 계산하여 reward state 안에 담는 함수입니다.
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _calculReward
	 */
	const _calculReward = () => {
		if (inputAmountValue.length >= 1) {
			/** 
			 * 유저가 입력한 staking 값 * 등급에 따른 이자율 값
			 * @var realReward
			 * @type { (a: number, b: number) => number }
		    
			 */
			const realReward = multiply(
				bignumber(inputAmountValue),
				bignumber(levelAprPercent)
			);
			const realXReaward = parseFloat(realReward);
			setReward(realXReaward);
		} else if (inputAmountValue.length == 0) {
			setInputAmountValue('');
		}
	};
	/**
	 * huobi_global 기준 kct의 전일 종가를 가져오는 api를 호출하여 state에 담는 함수입니다.
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @async
	 * @function _houbiApiTime
	 */
	const _houbiApiTime = async () => {
		let apiTime = await huobi_closing_price();
		let apiData = apiTime && apiTime.results.kctusdt.price;
		setHuobiPrice(apiData);
	};
	/**
	 * @description userData.sub_wallet_address가 있을때 실행하는 유저 데이터 체크 함수.
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @param {string} MainAddress
	 * @param {string} SubAddress
	 * @async
	 * @function promise_CheckUser_IsStaking
	 */
	const promise_CheckUser_IsStaking = async (MainAddress, SubAddress) => {
		const post_checkUserStaking = await axios.post(
			`${process.env.REACT_APP_BACKEND_API}/kct/check_userstaking`,
			{
				walletAddress: MainAddress,
			}
		);
		const post_SubWalelt_checkUserStaking = await axios.post(
			`${process.env.REACT_APP_BACKEND_API}/kct/check_userstaking`,
			{
				walletAddress: SubAddress,
			}
		);
		Promise.all([
			post_checkUserStaking,
			post_SubWalelt_checkUserStaking,
		]).then(result => {
			if (
				result[0].data.RETCODE === 'USER_STAKING_LIST_CHECK_SENDING' ||
				result[1].data.RETCODE === 'USER_STAKING_LIST_CHECK_SENDING'
			) {
				setSendingCheck(true);
			} else {
				setSendingCheck(false);
				const MainAddressResult =
					result[0].data.results?.processing[0]?.staking_mount ?? 0;
				const SubAddressResult =
					result[1].data.results?.processing[0]?.staking_mount ?? 0;
				setMyStakingMount(MainAddressResult + SubAddressResult);
				// setMyStakingMount(MainAddress);
				setNewUserAmount(MainAddressResult ?? 0);
				setCheckUserStaking(result[1].data.results);
			}
		});
	};
	/**
	 * staking 시도시, 시도후, 마운트시 유저의 staking state를 확인하는 함수입니다.
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @async
	 * @function _check_userIsStaking
	 */
	const _check_userIsStaking = async (
		MainWalletAddress,
		SubWalletAddress
	) => {
		try {
			let post_checkUserStaking;
			if (SubWalletAddress) {
				promise_CheckUser_IsStaking(
					MainWalletAddress,
					SubWalletAddress
				);
			} else {
				post_checkUserStaking = await axios.post(
					`${process.env.REACT_APP_BACKEND_API}/kct/check_userstaking`,
					{
						walletAddress: MainWalletAddress,
					}
				);
				/**
				 * staking state 확인을 위한 axios 요청입니다.
				 * @author ydw <teammapa.ydw@gmail.com>
				 * @function post_checkUserStaking
				 * @return {object} userData
				 */
				if (post_checkUserStaking) {
					if (
						post_checkUserStaking.data.RETCODE ===
						'USER_STAKING_LIST_CHECK_SENDING'
					) {
						setSendingCheck(true);
					} else {
						setSendingCheck(false);
						setMyStakingMount(
							post_checkUserStaking.data.results.processing[0]
								?.staking_mount ?? 0
						);
						setNewUserAmount(
							post_checkUserStaking.data.results.processing
								?.staking_mount ?? 0
						);
						setCheckUserStaking(post_checkUserStaking.data.results);
					}
				} else {
				}
			}
		} catch (error) {
			if (error && error?.code !== 'ERR_NETWORK') {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'유저의 스테이킹 정보를 확인 실패',
					JSON.stringify(error)
				);
			}
		}
	};

	/**
	 * staking 시작 함수 & 유저의 staking state가 sending 인지 체크
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _check_sending_userStaking
	 * @async
	 */
	const _check_sending_userStaking = async () => {
		setLoading(true);
		setStakeBtnChecked(false);
		stakeInputBtn.current.checked = false;
		try {
			/**
			 * 유저의 staking state가 sending인지 확인을 위한 axios 요청입니다.
			 * @author ydw <teammapa.ydw@gmail.com>
			 * @function checkSending
			 * @return {object} userData
			 */
			const checkSending = await axios.post(
				`${process.env.REACT_APP_BACKEND_API}/kct/check_userstaking`,
				{
					walletAddress: `${address}`,
				}
			);
			if (checkSending) {
				if (
					checkSending.data.RETCODE ===
					'USER_STAKING_LIST_ADD_CHECK_PROCEEDING'
				) {
					alert(`${textData && textData.mypage2.StakingError3}`);
					throw Error(checkSending);
				} else {
					_inputActionLog(
						JSON.stringify(_inputLogAccount),
						'유저의 스테이킹 정보 확인 성공',
						checkSending.data.RETCODE
					);
					const stakingStart = await _stakingBridge(
						checkSending.data
					);
				}
			} else {
				alert(`${textData && textData.mypage2.StakingError}`);
				throw Error(checkSending);
			}
		} catch (error) {
			alert(`${textData && textData.mypage2.StakingError3}`);
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'유저의 스테이킹 정보 확인 실패',
				JSON.stringify(error)
			);
			setLoading(false);
		}
	};

	/**
	 * staking을 시작하며 유저의 상태를 먼저 체크
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @param {object} checksending - 유저의 staking state가 sending 상태인지 확인한 api return 값
	 * @async
	 * @function _stakingBridge
	 */
	const _stakingBridge = async checksending => {
		setLoading(true);
		try {
			await _getstakingInfo();
			if (checksending.RETCODE == 'USER_STAKING_LIST_CHECK_SENDING') {
				alert(`${textData && textData.mypage2.StakingError1}`);
				throw new Error(checksending.RETCODE);
			} else if (
				checksending.RETCODE !==
					'USER_STAKING_LIST_ADD_CHECK_CONFIRMED' &&
				checksending.RETCODE !== 'USER_STAKING_LIST_CHECK_COMPLETED' &&
				checksending.RETCODE !==
					'USER_STAKING_LIST_ADD_CHECK_PROCEEDING'
			) {
				alert(`${textData && textData.mypage2.StakingError1}`);
				throw new Error(checksending.RETCODE);
			} else {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'스테이킹 시작 전 유저의 스테이킹 정보 호출 성공',
					checksending.RETCODE
				);
				const stakingStart = await _staking();
			}
		} catch (error) {
			alert(
				`error catch : ${textData && textData.mypage2.StakingError2}`
			);
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'스테이킹 시작 전 유저의 스테이킹 정보 호출 실패',
				error
			);
			setLoading(false);
		}
	};

	/**
	 * staking 진행을 위해 유저 지갑에 서명을 요청합니다.
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function @name _check_sending_userStaking
	 * @async
	 */
	const _staking = async () => {
		setLoading(true);
		execute_approve({
			recklesslySetUnpreparedOverrides: {
				gasPrice: gasData.gasPrice,
				gasLimit: 210000,
			},
		});
	};
	/**
	 * staking approve가 정상적으로 요청된 이후 staking이 진핸된 유저 정보 가져옴
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _afterCheck_userIsStaking
	 * @async
	 * @param {string} approve 의 결과값 txhash
	 */
	const _afterCheck_userIsStaking = async txhash => {
		setLoading(true);
		try {
			/**
			 * staking이 정상적으로 처리되었는지 확인 및 유저의 staking 정보를 불러옴
			 * @author ydw <teammapa.ydw@gmail.com>
			 * @function post_checkUserStaking
			 * @return {object} userData
			 */
			const post_checkUserStaking = await axios.post(
				`${process.env.REACT_APP_BACKEND_API}/kct/check_userstaking`,
				{
					walletAddress: address,
				}
			);
			if (post_checkUserStaking) {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'스테이킹 금액 전송 허용 후 유저의 스테이킹 정보 확인 성공',
					JSON.stringify(post_checkUserStaking)
				);
				alert(`${textData && textData.mypage2.StakingSuccess} `);
				setStakeBtnChecked(false);
				await _add_userStaking(txhash);
			} else {
				throw new Error(post_checkUserStaking.data.results);
			}
		} catch (error) {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'스테이킹 금액 전송 허용 후 유저의 스테이킹 정보 확인 실패',
				JSON.stringify(error)
			);
			setLoading(false);
			alert(`${textData && textData.mypage2.StakingError2} `);
		}
	};

	/**
	 * staking을 시도한 유저를 목록에 추가
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _add_userStaking
	 * @async
	 * @param {string} approve 의 결과값 txhash
	 */
	const _add_userStaking = async txhash => {
		setLoading(true);
		let realvalue =
			inputAmountValue.length > 1
				? parseFloat(inputAmountValue)
				: inputAmountValue;
		_setMembership();
		const membershipLevelIndex =
			userStakingInfo[0].staking_period_index[periodIndex]?.index;
		if (
			address.length > 1 &&
			membershipLevelIndex &&
			inputAmountValue > 0 &&
			txhash.length > 1
		) {
			try {
				/**
				 * staking이 정상적으로 처리된 유저를 목록에 추가
				 * @author ydw <teammapa.ydw@gmail.com>
				 * @function addUserStaking
				 * @return {object} userData
				 */
				const addUserStaking = await axios.post(
					`${process.env.REACT_APP_BACKEND_API}/kct/add_userstaking`,
					{
						walletAddress: address.toString().toLowerCase(),
						staking_period_index: membershipLevelIndex?.toString(),
						// 유저 등급과 예치 기간에 따른 인덱스 값을 찾아서 보내야함
						stakingAmount: Math.floor(realvalue * 10000) / 10000,
						staking_info_index:
							'9a6158f0-25d0-4e09-a3d7-18189871e85c',
						sendingTxHash: `${txhash}`,
					}
				);
				if (addUserStaking) {
					if (
						addUserStaking.data.RETCODE ==
							'USER_STAKING_LIST_ADD_COMPLETE' ||
						addUserStaking.data.RETCODE ==
							'USER_STAKING_LIST_ADD_PROCEEDING' ||
						addUserStaking.data.RETCODE ==
							'USER_STAKING_LIST_ADD_CHECK_CONFIRMED'
					) {
						_inputActionLog(
							JSON.stringify(_inputLogAccount),
							'스테이킹 유저 목록 추가 성공',
							addUserStaking.data.RETCODE
						);
						_check_userIsStaking();
						_getstakingInfo();
					}
				} else {
					alert(`${textData && textData.mypage2.StakingError8} `);
					throw new Error(addUserStaking.data.RETCODE);
				}
			} catch (error) {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'스테이킹 유저 목록 추가 실패',
					JSON.stringify(error)
				);
				alert(
					`error catch : ${
						textData && textData.mypage2.StakingError8
					} `
				);
			} finally {
				setInputAmountValue(0);
				setLoading(false);
				setUserCandoStaking(false);
			}
		} else {
			setLoading(false);
			setUserCandoStaking(false);
			setInputAmountValue(0);
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'스테이킹 유저 목록 추가 실패 (조건 오류)',
				JSON.stringify(membershipLevelIndex, inputAmountValue, txhash)
			);
			alert(
				`add User Staking Error: ${
					textData && textData.mypage2.StakingError8
				} `
			);
		}
	};
	/**
	 * staking을 진행한 유저의 이자 계산
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _calculateYield
	 * @async
	 * @return {number} 이자율
	 */
	const _calculateYield = async () => {
		try {
			return ethers.utils.formatEther(calculatedYield);
		} catch (error) {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'스테이킹 이자 계산 실패',
				JSON.stringify(error)
			);
		}
	};
	/**
	 * Staking 이자 정산 이후 유저 상태 변경
	 * @param {string} hash
	 * @async
	 * @function _request_userStaking_interest
	 */
	const _request_userStaking_interest = async hash => {
		setLoading(true);
		try {
			const post_claimYield = await axios.post(
				`${process.env.REACT_APP_BACKEND_API}/kct/request_userstaking_interest`,
				{
					walletAddress: address.toString(),
					requestUserstakingInterestTxhash: hash.toString(),
				}
			);
			if (post_claimYield) {
				if (
					post_claimYield.data.RETCODE ==
					'REQUEST_USERSTAKING_INTEREST_SUCCESS'
				) {
					_inputActionLog(
						JSON.stringify(_inputLogAccount),
						'_request_userStaking_interest',
						post_claimYield.data.RETCODE
					);
				} else {
					alert(`${textData && textData.mypage2.StakingError10} `);
					throw new Error(post_claimYield.data.RETCODE);
				}
			}
		} catch (error) {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'_request_userStaking_interest error',
				JSON.stringify(error)
			);
			alert(
				`error catch : ${textData && textData.mypage2.StakingError10} `
			);
		} finally {
			setLoading(false);
		}
	};
	/**
	 * staking 기간이 종료된 유저의 이자만 가져감 (임시)
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _claim_Yield
	 * @async
	 */
	const _claim_Yield = async () => {
		await _getstakingInfo();
		setLoading(true);
		if (parseFloat(calculatedYield) > 0) {
			execute_claimYield();
		} else {
			alert(
				`error catch : ${textData && textData.mypage2.StakingError11} `
			);
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'스테이킹 이자 정산 실패 (조건 오류)',
				`${parseFloat(calculatedYield)} `
			);
			setLoading(false);
		}
	};
	/**
	 * staking 기간이 종료된 유저의 이자 + 원금을 가져감 (임시)
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _withdrawStake
	 * @async
	 */
	const _withdrawStake = async () => {
		await _getstakingInfo();
		setLoading(true);
		if (parseFloat(calculatedYield) > 0) {
			execute_withdrawStake();
		} else {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'Staking 이자,원금 출금 조건 오류',
				`${parseFloat(calculatedYield)} `
			);
			alert(
				`error catch : ${textData && textData.mypage2.StakingError13} `
			);
			setLoading(false);
		}
	};
	/**
	 * Staking 종료 요청 실행
	 * @function request_userunstaking
	 * @async
	 */
	const request_userunstaking = async () => {
		setLoading(true);
		try {
			const post_withdraw = await axios.post(
				`${process.env.REACT_APP_BACKEND_API}/kct/request_userunstaking`,
				{
					walletAddress: address.toString(),
				}
			);
			if (post_withdraw) {
				if (
					post_withdraw.data.RETCODE ==
					'REQUEST_USERUNSTAKING_SUCCESS'
				) {
					_inputActionLog(
						JSON.stringify(_inputLogAccount),
						'request_userunstaking',
						post_withdraw.data.RETCODE
					);
				} else {
					throw new Error(post_withdraw.data.RETCODE);
				}
			}
		} catch (error) {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'request_userunstaking',
				JSON.stringify(error)
			);
			alert(
				`error catch : ${textData && textData.mypage2.StakingError12} `
			);
		} finally {
			setLoading(false);
		}
	};

	/**
	 * 현재 staking이 진행된 전체 유저 정보를 가져옴 method post
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function postStakingInfo
	 * @async
	 */
	async function postStakingInfo() {
		const stakingInfo = await _postStakingInfo();
		_setAllUserAmount(stakingInfo.results.totalStakingAmount);
	}

	/**
	 * 현재 staking이 진행된 전체 유저 정보를 가져옴 method get
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function postStakingInfo
	 * @async
	 */
	async function _getstakingInfo() {
		const stakingInfo = await _stakingInfo();

		// null is not function 아이폰 이슈
		let checkUserStateArr = [];
		await Promise.all(
			stakingInfo.data[0].staking_list_index.map(async x => {
				if (x.user_address.toString().toLowerCase() === address) {
					checkUserStateArr.push(x.staking_state);
				}
			})
		);

		let UserAmount = 0;
		let myAmount = 0;
		const allUserAmount =
			stakingInfo &&
			stakingInfo.data &&
			stakingInfo.data[0]?.staking_list_index
				.map(item => item.staking_mount)
				.reduce(
					(prevvalue, currentvalue) => prevvalue + currentvalue,
					UserAmount
				);
		setAllUserAmount(allUserAmount);
		setUserStakingInfo(stakingInfo.data);
		setUserCandoStaking(true);
		if (checkUserStateArr.length >= 1) {
			setCheckUserState(checkUserStateArr[0]);
		}
	}

	/**
	 * 현재 staking이 진행된 전체 유저 정보를 가져옴 method post
	 * @param {number} currentValue 유저 입력 값
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _changeInputValue
	 * @async
	 * @return {state} InputAmoutValue
	 */
	const _changeInputValue = currentValue => {
		if (+currentValue > +myBalance) {
			setInputAmountValue(myBalance);
		} else if (+currentValue <= +myBalance) {
			setInputAmountValue(currentValue);
			setDivideAmount('');
		} else if (currentValue.length === 0) {
			setInputAmountValue(0);
		} else {
			setInputAmountValue(currentValue);
		}
	};

	/**
	 * 다음 멤버십 획득까지 필요한 예치 수량을 확인
	 * @author hoo <teammapa.jihoo@gmail.com>
	 * @function nextMembership
	 * @return {Number} 다음 멤버십 획득에 필요한 값
	 */
	const nextMembership = () => {
		switch (membership) {
			case 'bronze':
				setNextMembershipPrice(
					(membershipStandard[1].kct - myStakingMount).toFixed(3)
				);
				break;
			case 'silver':
				setNextMembershipPrice(
					(membershipStandard[2].kct - myStakingMount).toFixed(3)
				);
				break;
			case 'gold':
				setNextMembershipPrice(
					(membershipStandard[3].kct - myStakingMount).toFixed(3)
				);
				break;
			case 'black':
				setNextMembershipPrice(
					(membershipStandard[4].kct - myStakingMount).toFixed(3)
				);
				break;
			case 'platinum':
				setNextMembershipPrice('플래티넘');
				break;
			default:
				setNextMembershipPrice(
					(membershipStandard[0].kct - myStakingMount).toFixed(3)
				);
		}
	};

	const devideMap = {
		'25%'() {
			setDivideAmount('25%');
			setInputAmountValue(myBalance * 0.25);
		},
		'50%'() {
			setDivideAmount('50%');
			setInputAmountValue(myBalance * 0.5);
		},
		'75%'() {
			setDivideAmount('75%');
			setInputAmountValue(myBalance * 0.75);
		},
		MAX() {
			setDivideAmount('MAX');
			setInputAmountValue(myBalance);
		},
	};
	/**
	 * 현재 staking이 진행된 전체 유저 정보를 가져옴 method post
	 * @param {string} devidePercent n% 버튼 클릭 값
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _devideAmount
	 * @return {state} divideAmount, InputAmountValue
	 */
	const _devideAmount = devidePercent => {
		devideMap[devidePercent]();
	};
	const _DurationAprMap = {
		'180D': () => {
			setDurationApr('180D');
		},
		'365D': () => {
			setDurationApr('365D');
		},
	};
	/**
	 * Duration APR outline 활성화 함수입니다.
	 * @param {string} durationApr staking 기간 설정 버튼 클릭 값
	 * @author ydw <teammapa.ydw@gmail.com>
	 * @function _checkDuration
	 * @return {state} durationApr
	 */
	const _checkDuration = durationApr => {
		_DurationAprMap[durationApr]();
	};

	const chainCheck = async () => {
		// 연결된 네트워크가 다른 네트워크인지 확인
		let web3;
		// 미인증 && web3 관련 미로딩시에만 enableWeb3를 작동하여 already has been called 중복 방지
		// mypage에서 home의 로그인 부분으로 이동
		if (
			process.env.REACT_APP_ENV === 'live' ||
			process.env.REACT_APP_ENV === 'livetest'
		) {
			if (isConnected) {
				// [완료] 모바일 임시 처리
				// PC용 네트워크 체크
				if (
					process.env.REACT_APP_CHAIN_TARGET === 'ethereum' &&
					chainId !== 1
				) {
					alert(textData.mypage2.checkNetwork);
					history.push({
						pathname: '/',
					});
				}
			}
		}
		if (
			process.env.REACT_APP_ENV === 'local' ||
			process.env.REACT_APP_ENV === 'testdev'
		) {
			if (isConnected) {
				web3 = chains[0].id;
				if (
					process.env.REACT_APP_CHAIN_TARGET === 'goerli' &&
					chainId !== 5
				) {
					alert(textData.mypage2.checkNetwork);
					history.push({
						pathname: '/',
					});
				}
			}
		} // 모바일용 네트워크 체크
	};

	/**
	 * onChain 아이템 업데이트
	 * @author yunji <teammapa.sophiyuu@gmail.com>
	 * @function _fetchOnChainCollectionItems
	 * @async
	 * @return {object} OnChainCollectionData 업데이트
	 */
	async function _fetchOnChainCollectionItems(address, signer) {
		try {
			const pfpContract = new ethers.Contract(
				PFP_CONTRACT.address,
				PFP_CONTRACT.abi,
				signer
			);

			const shillaContract = new ethers.Contract(
				SHILLA_CONTRACT.address,
				SHILLA_CONTRACT.abi,
				signer
			);

			const myPFPTokenIds = await pfpContract.getTokenIds(address);
			const myShillaTokenIds = await shillaContract.getTokenIds(address);

			let myPFPTokenIds_mapped = myPFPTokenIds.map(num =>
				ethers.BigNumber.from(num).toNumber()
			);
			let myShillaTokenIds_mapped = myShillaTokenIds.map(num =>
				ethers.BigNumber.from(num).toNumber()
			);

			// new
			const tokenSetFunc = async () => {
				let result_pfp = await _getOnChainCollectionItems(
					myPFPTokenIds_mapped,
					address
				);
				let result_shilla = await _getOnChainCollectionItems(
					myShillaTokenIds_mapped,
					address
				);

				return [...result_pfp, ...result_shilla];
			};

			let tokenArr = await tokenSetFunc();

			return tokenArr;
		} catch (error) {}
	}
	/**
	 * offChain 아이템 업데이트
	 * @author yunji <teammapa.sophiyuu@gmail.com>
	 * @function _fetchOffChainCollectionItems
	 * @async
	 * @return {object} OffChainCollectionData 업데이트
	 */
	async function _fetchAllCollectionItems(
		categoryList,
		mainCategoryIndex,
		// subCategoryIndex,
		address,
		userData,
		signer
	) {
		setLoading(true);
		/**
		 * offChain 아이템 업데이트 (Box,Products)
		 * 비동기 처리용
		 * @author yunji <teammapa.sophiyuu@gmail.com>
		 * @var getFunctions
		 * @type {[function,function]}
		 * @returns {object} setOffChainCollectionData
		 */
		let getFunctions = [
			_getOffChainCollectionBoxes(address),
			_getOffChainCollectionProducts(address),
			_fetchOnChainCollectionItems(address, signer),
		];

		if (userData?.sub_wallet_address) {
			getFunctions = getFunctions.concat([
				_getOffChainCollectionBoxes(userData?.sub_wallet_address),
				_getOffChainCollectionProducts(userData?.sub_wallet_address),
				_fetchOnChainCollectionItems(
					userData?.sub_wallet_address,
					signer
				),
			]);
		}

		Promise.allSettled(getFunctions)
			.then(results => {
				let totalList = [];
				let filteredlist;

				results.forEach(result => {
					if (result.status === 'fulfilled') {
						totalList = totalList.concat(result.value);
					}
				});
				setAllCollectionData(totalList);

				if (
					(mainCategoryIndex !== 0 && categoryList.length <= 4) ||
					categoryList.length > 4
				) {
					filteredlist = _categorizeAtKonnectWallet(
						totalList,
						categoryList,
						mainCategoryIndex
					);
				} else if (
					mainCategoryIndex === 0 &&
					categoryList.length <= 4
				) {
					const membershipItemList = _categorizeAtKonnectWallet(
						totalList,
						categoryList,
						1
					);

					const nftItemList = _categorizeAtKonnectWallet(
						totalList,
						categoryList,
						2
					);

					const boxItemList = _categorizeAtKonnectWallet(
						totalList,
						categoryList,
						3
					);

					filteredlist = {
						0: [
							...membershipItemList[0],
							...nftItemList[0],
							...boxItemList[0],
						],
						1: membershipItemList[0],
						2: nftItemList[0],
						3: boxItemList[0],
					};
				}

				setFilteredAllCollectionData(filteredlist);
			})
			.catch(error => {})
			.finally(() => {
				setLoading(false);
			});
	}

	/**
	 * onChain 아이템 업데이트
	 * @param {object} product
	 * @author yunji <teammapa.sophiyuu@gmail.com>
	 * @function _transferToOnChain
	 * @async
	 * @return {object} OffChainCollectionData 업데이트
	 */
	async function _transferToOnChain(product) {
		//임시 : 서브 지갑 주소는 리딤, 언박싱 차단
		if (
			product.wallet_address.toLowerCase() ===
			userData?.sub_wallet_address?.toLowerCase()
		) {
			alert(textData.mypage2.oldWalletError); //TODO : message input
			return;
		}

		let voucherData;
		if (!isConnected) {
			alert(
				`${textData.header['Please proceed with the wallet signature']} `
			);
			return;
			// 온체인 로그인
		}
		setLoading(true);
		try {
			voucherData = await _exportTokenToLazyMint(address, product);
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'NFT 바우처 생성 성공',
				JSON.stringify(voucherData)
			);
		} catch (error) {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'NFT 바우처 생성 실패',
				JSON.stringify(error)
			);
			alert(textData.myPage['export token error']);
			setLoading(false);
			return;
		}

		try {
			const voucher = Object.values(JSON.parse(voucherData.data));
			const args =
				product.product_index.category === 'PFP'
					? [PFP_CONTRACT.address, PFP_CONTRACT.abi]
					: [SHILLA_CONTRACT.address, SHILLA_CONTRACT.abi];

			const contract = new ethers.Contract(...args, signer);
			const transaction = await contract.redeem(
				address.toLowerCase(),
				voucher
			);
			if (Object.keys(transaction).length > 0) {
				_inputActionLog(
					JSON.stringify(_inputLogAccount),
					'NFT를 온체인으로 전송 성공',
					JSON.stringify({ voucher, transaction })
				);
				await _reportCompleteExportTokenToLazyMint(address, product);
				alert(textData.myPage['redeem success']);
			}
		} catch (error) {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'NFT를 온체인으로 전송 실패',
				JSON.stringify(error)
			);

			if (error.data.code === -32000) {
				alert(`${textData.mypage2.StakingError16}`);
				return null;
			}

			const _moralis_db_update_rollback =
				await moralis_db_update_rollback(product.nft_no, address);
			if (_moralis_db_update_rollback === 'success') {
				alert(textData.myPage['redeem error']);
				return null;
			} else {
				alert(
					`${textData.myPage['redeem error']} _moralis_db_update_rollback fail`
				);
				return null;
			}
		} finally {
			await _fetchAllCollectionItems(
				categoryList_kw,
				selectedCategoryMain_kw,
				address,
				userData,
				signer
			);
			setLoading(false);
		}
	}
	/**
	 * mypage Box unboxing
	 * @param {object} box
	 * @author yunji <teammapa.sophiyuu@gmail.com>
	 * @function _unboxing
	 * @async
	 * @return {object} _fetchOffChainCollectionItems 업데이트
	 */
	async function _unboxing(box) {
		if (
			box?.wallet_address.toLowerCase() ===
			userData?.sub_wallet_address?.toLowerCase()
		) {
			alert(textData.mypage2.oldWalletError);
			return;
		}

		setLoading(true);
		try {
			const result = await _unbox(address, box.index);
			if (result.RETCODE === 'UNBOXING_COMPLETED') {
				if (box.type === 'pfp_duman') {
					_inputActionLog(
						JSON.stringify(_inputLogAccount),
						'박스 오픈 성공',
						result.RETCODE
					);
					// duman
					setOpenBox({
						isOpen: true,
						imgUrl: `${process.env.REACT_APP_BACKEND_API}/kct/nftImage/${result.results[0].ipfs_image_local_url} `,
					});
				} else if (box.type === 'utility') {
					_inputActionLog(
						JSON.stringify(_inputLogAccount),
						'박스 오픈 성공',
						result.RETCODE
					);
					// shilla
					setShillaModal({
						isOpen: true,
						unbox: true,
						imgUrl: `${process.env.REACT_APP_BACKEND_API}/kct/nftImage/${result.results[0].ipfs_image_local_url} `,
					});
				} else {
					alert('unboxing failed');
					return false;
				}
			}
		} catch (error) {
			_inputActionLog(
				JSON.stringify(_inputLogAccount),
				'박스 오픈 실패',
				JSON.stringify(error)
			);
			alert(textData.myPage['unbox error']);
		} finally {
			await _fetchAllCollectionItems(
				categoryList_kw,
				selectedCategoryMain_kw,
				address,
				userData,
				signer
			);
			setLoading(false);
		}
	}
	useLayoutEffect(() => {
		if (Category === 'allCollection') {
			const allCategoryList = _getAllCollectionCategoryList(
				isMobile || window.innerWidth <= 1200
			);
			setCategoryList_kw(allCategoryList);
		}
	}, [Category, isMobile]);

	useLayoutEffect(() => {
		if (Category === 'allCollection') {
			if (isConnected && categoryList_kw.length !== 0 && signer) {
				_fetchAllCollectionItems(
					categoryList_kw,
					selectedCategoryMain_kw,
					address,
					userData,
					signer
				);
			}
		}
	}, [
		Category,
		categoryList_kw,
		address,
		selectedCategoryMain_kw,
		selectedCategorySub_kw,
		userData,
		isConnected,
		signer,
	]);

	/**
	 * 전일 종가 * 유저의자산을 string으로 반환
	 * @type {(myBalance: number, huobiPrice: number) => string}
	 * @author ydw,yunji <teammapa.ydw@gmail.com> , <teammapa.shopiyuu@gmail.com>
	 * @function _totalBalance
	 * @async
	 * @return {string} _formatPrice 함수로 toLocaleString
	 */
	const _totalBalance = () => {
		const parts = myBalance * huobiPrice;
		if (parts) {
			return _formatPrice(parts);
		}
		return '';
	};
	/**
	 * 전일 종가 * 유저 staking 값을 string으로 반환
	 * @type {(myStakingMount: number, huobiPrice: number) => string}
	 * @author ydw,yunji <teammapa.ydw@gmail.com> , <teammapa.shopiyuu@gmail.com>
	 * @function _kctStakingAmount
	 * @async
	 * @return {string} _formatPrice 함수로 toLocaleString
	 */
	const _kctStakingAmount = () => {
		const parts = myStakingMount * huobiPrice;
		if (parts) {
			return _formatPrice(parts);
		}
		return '';
	};
	/**
	 * 전일 종가 * 모든유저 staking 값을 string으로 반환
	 * @type {(_alluserAmount: number, huobiPrice: number) => string}
	 * @author ydw,yunji <teammapa.ydw@gmail.com> , <teammapa.shopiyuu@gmail.com>
	 * @function _kctStakingAmount
	 * @async
	 * @return {string} _formatPrice 함수로 toLocaleString
	 */
	const _AllUserStakingAmount = () => {
		const parts = _alluserAmount * huobiPrice;
		if (parts) {
			return _formatPrice(parts);
		}
		return '';
	};

	return (
		<div id='myPage'>
			{openEditModal ? (
				<EditModal
					setOpenEditModal={setOpenEditModal}
					setNickName={setNickName}
					nickName={nickName}
				/>
			) : null}
			{loading && <Loading />}
			{membershipModal ? (
				<MembershipModal
					data={membershipStandard}
					textData={textData}
					modal={membershipModal}
					setModal={setMembershipModal}
				/>
			) : null}
			{boxDetailModal ? (
				<BoxDetailModal onClick={_unboxing} textData={textData} />
			) : null}
			<Header handleAuth={handleAuth} />
			<TermsOfServiceModal
				modalVisible={termsModal}
				_setModalVisible={setTermsModal}
				setStakeBtnChecked={setStakeBtnChecked}
			/>
			<OpenAnimationModal
				videomodal={openBox}
				setVideoModal={setOpenBox}
				onClick={() => {
					if (categoryList_kw.length > 3) {
						setSelectedCategoryMain_kw(3);
					} else {
						setSelectedCategoryMain_kw(2);
					}
				}}
				textData={textData}
			/>
			{shillaModal ? (
				<ShillaOpenModal
					onClick={() => {
						setSelectedCategoryMain_kw(6);
						setShillaModal(false);
					}}
					modalVisible={shillaModal}
					_setModalVisible={setShillaModal}
					shillaImg={shillaImg}
					shillaData={shillaData}
					textData={textData}
				/>
			) : null}
			<MyPageHeader
				setCategory={setCategory}
				textData={textData}
				checkUserStaking={checkUserStaking}
				setMembershipModal={setMembershipModal}
				userMembership={membership}
				userStakingInfo={userStakingInfo}
				shillaModal={shillaModal}
				setOpenEditModal={setOpenEditModal}
				modalOpen={modalOpen}
				myBalance={myBalance}
				userEth={userEth}
				diffDay={diffDay}
				_totalBalance={_totalBalance}
				myStakingMount={myStakingMount}
				_kctStakingAmount={_kctStakingAmount}
				tierAmountMin={tierAmountMin}
				huobiPrice={huobiPrice}
				network={networkChain}
			/>
			<div className='myPage_content'>
				<Row className='card_list_wrap'>
					<Col lg='12' md='12' className='card_list_type'>
						<h3
							className={Category == 'allCollection' ? 'on' : ''}
							onClick={() => {
								setCategory('allCollection');
							}}>
							{textData && textData.mypage2.myWallet}
						</h3>
						<h3
							className={Category == 'staking' ? 'on' : ''}
							onClick={() => {
								setCategory('staking');
							}}>
							{textData && textData.mypage2.Deposit}
						</h3>
						{/* 스왑 임시 제거 */}
						<h3
							className={Category == 'Swap' ? 'on' : ''}
							onClick={() => {
								setCategory('Swap');
							}}>
							{textData && textData.mypage2.Swap}
						</h3>
					</Col>
				</Row>
				{/* KonnectWallet */}
				{Category === 'allCollection' && isConnected && (
					<>
						<KonnectWallet
							data={filteredAllCollectionData}
							categoryList={categoryList_kw}
							// categoryMainList={categoryMainList_kw}
							selectedCategoryMain={selectedCategoryMain_kw}
							setSelectedCategoryMain={setSelectedCategoryMain_kw}
							selectedCategorySub={selectedCategorySub_kw}
							setSelectedCategorySub={setSelectedCategorySub_kw}
							handleTransfer={_transferToOnChain}
							handleUnboxing={_unboxing}
							shillaModal={shillaModal}
							setShillaModal={setShillaModal}
							shillaData={shillaData}
							setShillaData={setShillaData}
							textData={textData}
							language={language}
							setBoxDetailModal={setBoxDetailModal}
							currentAddress={address}
						/>
					</>
				)}
				{/* staking 버튼을 누르면 나오는 컨텐츠 */}
				{
					Category == 'staking' && isConnected && (
						// window.innerWidth > 1200
						// ?
						<div className='staking_content_wrap'>
							<Row className='staking_content1'>
								<Col
									xl='6'
									lg='12'
									md='12'
									className='staking_view1'>
									<Row className='staking_view1_wrap1'>
										<Col
											xl='6'
											lg='12'
											md='12'
											className='staking_view1_totalTitle'>
											<h3>
												{textData &&
													textData.mypage2
														.TOTALKCTSTAKED}
											</h3>
										</Col>
										<Col
											xl='6'
											lg='12'
											md='12'
											className='staking_view1_totalView'>
											{window.innerWidth <= 1200 ? (
												<img
													src={stakeLogo}
													alt='logo'
													className='staking_view1_innerlogo'
												/>
											) : null}
											<h2>
												{_alluserAmount &&
													_formatPrice(
														_alluserAmount
													)}{' '}
												KCT
											</h2>
											{window.innerWidth <= 1200 ? (
												<h4>
													($ {_AllUserStakingAmount()}
													)
												</h4>
											) : (
												<h4>
													$ {_AllUserStakingAmount()}
												</h4>
											)}
										</Col>
									</Row>
									{window.innerWidth > 1200 ? (
										<div className='staking_view1_wrap2'>
											<h3>
												{textData &&
													textData.mypage2
														.MEMBERSHIPSTANDARD}
											</h3>
											<Row className='staking_view1_content'>
												{membershipStandard.map(
													(_item, _index) => {
														return (
															<Col
																className='staking_view1_mapData'
																key={_index}>
																<div className='border_view'>
																	<div className='img_wrap'>
																		<img
																			src={
																				_item.img
																			}
																		/>
																	</div>
																	<h3>
																		{
																			_item.level
																		}
																	</h3>
																	<h4>
																		(
																		{_formatPrice(
																			_item.usdt
																		)}{' '}
																		USDT)
																	</h4>
																</div>
																<h3>
																	{_formatPrice(
																		_item.kct
																	)}{' '}
																	KCT
																</h3>
															</Col>
														);
													}
												)}
											</Row>
										</div>
									) : null}
								</Col>
								{window.innerWidth > 1200 ? (
									<Col
										lg='6'
										md='6'
										className='staking_view2'>
										<div className='staking_view2_title'>
											<h3>
												{textData &&
													textData.mypage2
														.STAKINGPOSITION}
											</h3>
										</div>
										<div className='staking_view2_position'>
											<div className='position'>
												<h3>
													{textData &&
														textData.mypage2
															.DURATION}
												</h3>
												<h3>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														checkUserStaking
															.processing[0]
															.staking_period}
													D
												</h3>
											</div>
											<div className='position'>
												<h3>
													{textData &&
														textData.mypage2.AMOUNT}
												</h3>
												<h3>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														_formatPrice(
															checkUserStaking
																.processing[0]
																.staking_mount
														)}{' '}
													KCT
												</h3>
											</div>
											<div className='position'>
												<h3>
													{textData &&
														textData.mypage2
															.redemptionDate}
												</h3>
												<h3>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														moment(
															checkUserStaking
																.processing[0]
																?.staking_end_date
														).format(
															'MMMM - DD - YYYY HH:MM'
														)}
												</h3>
											</div>
											<div className='position'>
												<h3>
													{textData &&
														textData.mypage2.REWARD}
												</h3>
												<h3>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														parseInt(
															_formatPrice(
																checkUserStaking
																	.processing[0]
																	.reward_amount
															)
														).toFixed(3)}{' '}
													KCT
												</h3>
											</div>
										</div>
										<div className='position_buttonWrap'>
											<div className='position_button'>
												<button
													disabled
													style={
														checkUserState ==
														'processing'
															? {
																	opacity:
																		'0.5',
																	border: '1px solid #fff',
																	color: '#fff',
															  }
															: { opacity: '0.5' }
													}
													onClick={() => {
														_claim_Yield();
													}}>
													{textData &&
														textData.mypage2
															.claimReward}
												</button>
												<p>
													{textData &&
														textData.mypage2
															.claimingrewardsText}
												</p>
											</div>
											<div className='position_button noneborderline'>
												<button
													disabled
													style={{ opcity: '0.5' }}
													onClick={() => {
														_withdrawStake();
													}}>
													{textData &&
														textData.mypage2
															.unstaking}
												</button>
												<p>
													{textData &&
														textData.mypage2
															.UnstakingText}
												</p>
											</div>
										</div>
									</Col>
								) : (
									<Col
										lg='12'
										md='12'
										className='staking_view2'>
										<div className='staking_view2_title'>
											<h3>
												{textData &&
													textData.mypage2
														.STAKINGPOSITION}
											</h3>
										</div>
										<div className='staking_view2_position'>
											<div className='position'>
												<h3>
													{textData &&
														textData.mypage2.Stake}
												</h3>
												<h3>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														checkUserStaking
															.processing[0]
															.staking_period}
													D
												</h3>
											</div>
											<div className='position'>
												<h3>LOCKED</h3>
												<h3>{myStakingMount} KCT</h3>
											</div>
											<div className='position'>
												<h3>UNLOCKS ON</h3>
												<h3>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														moment(
															checkUserStaking
																.processing[0]
																?.staking_end_date
														).format(
															'MMMM - DD - YYYY HH:MM'
														)}
												</h3>
											</div>
											<div className='position'>
												<h3>
													{textData &&
														textData.mypage2.REWARD}
												</h3>
												<h3>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														checkUserStaking
															.processing[0]
															.reward_amount}{' '}
													KCT
												</h3>
											</div>
										</div>
									</Col>
								)}
								{window.innerWidth <= 1200 ? (
									<>
										<div className='position_buttonWrap'>
											<div className='position_button'>
												<button
													disabled
													style={
														checkUserState ==
														'processing'
															? {
																	opacity:
																		'0.5',
																	border: '1px solid #fff',
																	color: '#fff',
															  }
															: { opacity: '0.5' }
													}
													onClick={() => {
														_claim_Yield();
													}}>
													Claim Reward
												</button>
												<p>
													{textData &&
														textData.mypage2
															.claimingrewardsText}
												</p>
											</div>
										</div>
									</>
								) : null}
							</Row>
							<Row className='staking_content2'>
								<Col
									xl='6'
									lg='12'
									md='12'
									className='staking_view3'>
									<div className='staking_view3_title'>
										<h2>
											{textData &&
												textData.mypage2.DETAIL}
										</h2>
									</div>
									<div className='border_right_position'>
										<div className='staking_inputWrap inputWrap1'>
											<h3>
												{textData &&
													textData.mypage2.AMOUNT}
											</h3>
											<div className='staking_amount'>
												<div className='staking_amount_input'>
													{/* 점검 */}
													<input
														type='number'
														placeholder='100 KCT'
														onWheel={e =>
															e.currentTarget.blur()
														}
														ref={inputamount}
														onChange={() => {
															_changeInputValue(
																inputamount?.current?.value.replace(
																	/(\.\d{4})\d+/g,
																	'$1'
																) ?? 0
															);
														}}
														max={`${myBalance}`}
														min={0}
														value={
															inputAmountValue ??
															0
														}
														maxLength='18'
													/>
												</div>
												<div className='staking_amount_buttonWrap'>
													<button
														className={
															divideAmount &&
															divideAmount ==
																'25%'
																? 'check'
																: ''
														}
														onClick={() => {
															_devideAmount(
																'25%'
															);
														}}>
														25%
													</button>
													<button
														className={
															divideAmount &&
															divideAmount ==
																'50%'
																? 'check'
																: ''
														}
														onClick={() => {
															_devideAmount(
																'50%'
															);
														}}>
														50%
													</button>
													<button
														className={
															divideAmount &&
															divideAmount ==
																'75%'
																? 'check'
																: ''
														}
														onClick={() => {
															_devideAmount(
																'75%'
															);
														}}>
														75%
													</button>
													<button
														className={
															divideAmount &&
															divideAmount ==
																'MAX'
																? 'check'
																: ''
														}
														onClick={() => {
															_devideAmount(
																'MAX'
															);
														}}>
														MAX
													</button>
												</div>
											</div>
										</div>
										<div className='staking_inputWrap inputWrap2'>
											<h3>
												{textData &&
													textData.mypage2.DURATION}
												<br />
												APR
											</h3>
											<div className='staking_duration'>
												<div className='staking_duration_buttonWrap'>
													{[180, 365].map(
														(period, _index) => {
															let availblePeriod = true;
															if (
																Object.keys(
																	checkUserStaking
																).length > 0 &&
																checkUserStaking
																	.processing
																	.length >
																	0 &&
																checkUserStaking
																	.processing[0]
																	.staking_period !==
																	period
															) {
																availblePeriod = false;
															}
															return (
																<button
																	className={
																		durationApr &&
																		durationApr ==
																			`${period}D`
																			? 'green'
																			: ''
																	}
																	onClick={() => {
																		_checkDuration(
																			`${period}D`
																		);
																	}}
																	disabled={
																		!availblePeriod
																	}
																	style={{
																		opacity:
																			availblePeriod
																				? 1
																				: 0.5,
																	}}
																	key={
																		_index
																	}>
																	{period}D
																</button>
															);
														}
													)}
												</div>
												{window.innerWidth > 1200 ? (
													<div className='staking_duration_text'>
														<span>
															{textData &&
																textData.mypage2
																	.EstimatedStaking}
														</span>
														<h3>|</h3>
														<h4>
															{membership
																? membership
																: 'N/A'}
														</h4>
														{/* <h3>{nextMembershipPrice}</h3> */}
													</div>
												) : (
													// <div className='staking_duration_text'>
													// 	<span>
													// 		다음 멤버십까지의 예치 금액
													// 	</span>
													// 	<h3>|</h3>
													// 	<h4>
													// 		{nextMembershipPrice ?? 0}
													// 	</h4>
													// 	{/* <h3>{nextMembershipPrice}</h3> */}
													// </div>
													<div className='staking_duration_text'>
														<h4>
															{membership
																? membership
																: 'N/A'}
														</h4>
														<span>
															{textData &&
																textData.mypage2
																	.EstimatedStaking}
														</span>
													</div>
												)}
											</div>
										</div>
										<div className='staking_inputWrap inputWrap3'>
											{window.innerWidth > 1200 ? (
												<h3 className='membership_lelvelapr'>
													{textData &&
														textData.mypage2
															.MEMBERSHIPLEVELAPR}
												</h3>
											) : (
												<h3 className='membership_lelvelapr'>
													{textData &&
														textData.mypage2
															.MEMBERSHIPLEVELAPR}
												</h3>
											)}
											<div className='staking_membership'>
												<div className='staking_line line1'>
													<span></span>
													<h3
														style={
															membership ===
															'bronze'
																? {
																		fontWeight:
																			'700',
																		color: 'white',
																  }
																: {
																		fontWeight:
																			'initial',
																  }
														}>
														BRONZE
													</h3>
													<h3
														style={
															membership ===
															'silver'
																? {
																		fontWeight:
																			'700',
																		color: 'white',
																  }
																: {
																		fontWeight:
																			'initial',
																  }
														}>
														SILVER
													</h3>
													<h3
														style={
															membership ===
															'gold'
																? {
																		fontWeight:
																			'700',
																		color: 'white',
																  }
																: {
																		fontWeight:
																			'initial',
																  }
														}>
														GOLD
													</h3>
													<h3
														style={
															membership ===
															'black'
																? {
																		fontWeight:
																			'700',
																		color: 'white',
																  }
																: {
																		fontWeight:
																			'initial',
																  }
														}>
														BLACK
													</h3>
													<h3
														style={
															membership ===
															'platinum'
																? {
																		fontWeight:
																			'700',
																		color: 'white',
																  }
																: {
																		fontWeight:
																			'initial',
																  }
														}>
														PLATINUM
													</h3>
												</div>
												<div className='staking_line line2'>
													<h3>180D</h3>
													<h3
														className={
															levelApr ==
															'bronze180D'
																? 'blue'
																: ''
														}>
														1%
													</h3>
													<h3
														className={
															levelApr ==
															'silver180D'
																? 'blue'
																: ''
														}>
														2%
													</h3>
													<h3
														className={
															levelApr ==
															'gold180D'
																? 'blue'
																: ''
														}>
														3%
													</h3>
													<h3
														className={
															levelApr ==
															'black180D'
																? 'blue'
																: ''
														}>
														5%
													</h3>
													<h3
														className={
															levelApr ==
															'platinum180D'
																? 'blue'
																: ''
														}>
														7%
													</h3>
												</div>
												<div className='staking_line line3'>
													<h3>365D</h3>
													<h3
														className={
															levelApr ==
															'bronze365D'
																? 'blue'
																: ''
														}>
														1.2%
													</h3>
													<h3
														className={
															levelApr ==
															'silver365D'
																? 'blue'
																: ''
														}>
														2.5%
													</h3>
													<h3
														className={
															levelApr ==
															'gold365D'
																? 'blue'
																: ''
														}>
														4%
													</h3>
													<h3
														className={
															levelApr ==
															'black365D'
																? 'blue'
																: ''
														}>
														8%
													</h3>
													<h3
														className={
															levelApr ==
															'platinum365D'
																? 'blue'
																: ''
														}>
														10%
													</h3>
												</div>
											</div>
										</div>
										<div className='staking_inputWrap inputWrap4'>
											<h3>
												{textData &&
													textData.mypage2.REWARD}
											</h3>
											<div className='staking_reward'>
												<input
													ref={inputRef}
													value={`≒ ${
														typeof inputAmountValue ===
														'number'
															? inputData
															: durationApr ===
															  '180D'
															? Reward / 2
															: Reward
													} `}
													readOnly
												/>
												<h4>KCT</h4>
											</div>
										</div>
									</div>
								</Col>
								<Col
									xl='6'
									lg='12'
									md='12'
									className='staking_view4'>
									<div className='staking_view4_title'>
										<h2>
											{textData &&
												textData.mypage2.SUMMARY}
										</h2>
									</div>
									<div className='staking_view4_container'>
										<div className='staking_view4_summary'>
											<div className='staking_summary summary1'>
												<h3>
													{textData &&
														textData.mypage2
															.stakingDate}
												</h3>
												<span>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														moment(
															checkUserStaking
																.processing[0]
																?.staking_start_date
														).format(
															'MMMM - DD - YYYY HH:MM'
														)}
												</span>
											</div>
											<div className='staking_summary summary2'>
												<h3>
													{textData &&
														textData.mypage2
															.redemptionDate}
												</h3>
												<span>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														moment(
															checkUserStaking
																.processing[0]
																?.staking_end_date
														).format(
															'MMMM - DD - YYYY HH:MM'
														)}
												</span>
											</div>
											<div className='staking_summary summary3'>
												<h3>
													{textData &&
														textData.mypage2
															.currentlyStaked}
												</h3>
												<span>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														_formatPrice(
															checkUserStaking
																.processing[0]
																.staking_mount
														)}{' '}
													KCT
												</span>
											</div>
											<div className='staking_summary summary4'>
												<h3>
													{textData &&
														textData.mypage2
															.newStakingAmount}
												</h3>
												<span>
													{/* {Object.keys(checkUserStaking)
													.length > 0 &&
													checkUserStaking.processing
														.length > 0 &&
													_formatPrice(
														checkUserStaking
															.processing[0]
															.add_staking_mount
													)} */}
													{inputAmountValue} KCT
												</span>
											</div>
										</div>
										<div className='total_summary_wrap'>
											<div className='staking_summary_total total_summary1'>
												<h3>
													{textData &&
														textData.mypage2
															.totalStaked}
												</h3>
												<span>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														_formatPrice(
															checkUserStaking
																.processing[0]
																.staking_mount +
																+inputAmountValue
														)}{' '}
													KCT
												</span>
											</div>
											<div className='staking_summary_total total_summary2'>
												<h3>
													{textData &&
														textData.mypage2
															.averageAPR}
												</h3>
												<span>{_checkapr()} %</span>
											</div>
											<div className='staking_summary_total total_summary3'>
												<h3>Rewards on Unlock</h3>
												<span>
													{Object.keys(
														checkUserStaking
													).length > 0 &&
														checkUserStaking
															.processing.length >
															0 &&
														_formatPrice(
															checkUserStaking
																.processing[0]
																.reward_amount
														)}{' '}
													KCT
												</span>
											</div>
										</div>
										<div className='total_summary_lastWrap'>
											<p>
												{textData &&
													textData.mypage2.ONCESTAKED}
											</p>
											<div className='total_summary_lastText'>
												<input
													type={'checkbox'}
													ref={stakeInputBtn}
													checked={stakeBtnChecked}
													onChange={() => {
														_checkHandler();
													}}
												/>
												{loacalelang == 'en' ? (
													<label>
														{textData &&
															textData.mypage2
																.termsofService1}{' '}
														<span>
															<a
																style={{
																	cursor: 'pointer',
																}}
																onClick={() => {
																	setTermsModal(
																		true
																	);
																}}>
																{textData &&
																	textData
																		.mypage2
																		.termsofService2}
															</a>
														</span>
													</label>
												) : (
													<label>
														<span
															style={{
																color: '#ccc',
															}}>
															{textData &&
																textData.mypage2
																	.termsofService}{' '}
														</span>
														<span>
															<a
																style={{
																	cursor: 'pointer',
																}}
																onClick={() => {
																	setTermsModal(
																		true
																	);
																}}>
																{textData &&
																	textData
																		.mypage2
																		.termsofService2}{' '}
															</a>
														</span>
														<span
															style={{
																color: '#ccc',
															}}>
															{textData &&
																textData.mypage2
																	.termsofService3}
														</span>
													</label>
												)}
											</div>
											<button
												className={
													isStakeButtonActive &&
													stakeBtnChecked &&
													userCandoStaking
														? 'active'
														: ''
												}
												disabled={
													isStakeButtonActive &&
													stakeBtnChecked &&
													userCandoStaking
														? false
														: true
												}
												onClick={() => {
													_check_sending_userStaking();
												}}>
												{textData &&
													textData.mypage2.Stake}
											</button>
										</div>
									</div>
								</Col>
							</Row>
							{window.innerWidth <= 1200 && (
								<div
									className='position_button noneborderline'
									style={{
										opacity: '0.5',
										width: '90%',
										margin: 'auto',
										marginTop: '50px',
										paddingBottom: '50px',
										background:
											isMobile ||
											window.innerWidth <= 1200
												? 'transparent'
												: '#000',
									}}>
									<button
										disabled
										onClick={() => {
											_withdrawStake();
										}}
										style={{
											opacity: '0.5',
											fontSize: '14px',
										}}>
										{textData && textData.mypage2.unstaking}
									</button>
									<p>
										{textData &&
											textData.mypage2.UnstakingText}
									</p>
								</div>
							)}
						</div>
					)
					// : <M_Staking
					// 	userStakingInfo={userStakingInfo}
					// />
				}
				{Category === 'Swap' && isConnected && (
					<Row className='Swap_content'>
						<Col lg='12' md='12' className='card_list'>
							<Row className='Swap_uniswap_container'>
								<div className='uniswap' id='uniswap'>
									<SwapWidget
										provider={signer.provider}
										jsonRpcUrlMap={
											process.env.REACT_APP_ALCHEMY_URL
										}
										defaultInputTokenAddress={'NATIVE'}
										defaultOutputTokenAddress={
											swapTokenList[0].address
										}
										tokenList={swapTokenList}
										hideConnectionUI={true}
										onError={error => {}}
										theme={swapWidgetDesign}
										width='100%'
									/>
								</div>
							</Row>
						</Col>
					</Row>
				)}
				{/* </Container> */}
			</div>
			<Footer />
		</div>
	);
};

export default Mypage;
